import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { IdCaptureProps, TrackEvent, VendorType } from '../types';

/**
 * Internal types that we don't want exposed to the consumer
 */
type InternalIdCaptureContextProps = {
  documentlessEnabled?: boolean;
  sdkVendor?: VendorType;
  onNetworkErrorFallbackToSDKCapture?: () => void;
  estimatedTime?: number;
  setSessionId?: (sessionId: string | undefined) => void;
};

export type IdCaptureContextValue = IdCaptureProps &
  InternalIdCaptureContextProps & {
    /**
     * * We want to make sure both client and loader are always
     * defined so we don't have to create fallbacks everywhere
     */
    client: NonNullable<IdCaptureProps['client']>;
    loader: ReactNode;
    onfidoSdkVersion: string;
    trackEvent: TrackEvent;
  };

export const IdCaptureContext = createContext<IdCaptureContextValue | undefined>(undefined);

export function useIdCapture(): IdCaptureContextValue {
  const value = useContext(IdCaptureContext);
  if (!value) {
    throw new Error('useIdCapture must be used within a IdCaptureProvider');
  }

  return value;
}
